import { useCustomizations } from '@client/new/hooks/use-customizations';

type UseIsCommunitiesV2EnabledResult = {
  isLoading: boolean;
  isEnabled: boolean;
};

export const useIsCommunitiesV2Enabled = (
  influencerId?: string | number,
): UseIsCommunitiesV2EnabledResult => {
  const { isLoading, customizations } = useCustomizations(
    influencerId ? String(influencerId) : undefined,
  );

  return {
    isLoading,
    isEnabled: customizations?.isCommunitiesV2Enabled === true,
  };
};
